export interface EmailSettings {
  Inbound?: string
  Outbound?: string
  Support?: string
}

export enum OrderProcessStep {
  ORDER_RESPONSE = 0,
  DESPATCH_ADVICE = 1,
  INVOICE = 2,
}

export enum DeliveryForecastProcessStep {
  CONFIRMATION = 0,
  DESPATCHADVICE = 1,
  DESPATCHADVICE_WITH_CONFIRMATION = 2,
}
